import { render, staticRenderFns } from "./MatterbridgeSettings.vue?vue&type=template&id=402d953e&scoped=true"
import script from "./MatterbridgeSettings.vue?vue&type=script&lang=js"
export * from "./MatterbridgeSettings.vue?vue&type=script&lang=js"
import style0 from "./MatterbridgeSettings.vue?vue&type=style&index=0&id=402d953e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d953e",
  null
  
)

export default component.exports